// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ===============================================
 * OFF-SCREEN RENDERING UTILITIES
 * ===============================================
 * 
 * Purpose: Provide robust CSS classes for rendering elements off-screen
 * without affecting the main page layout, scroll position, or causing
 * visual artifacts (flashing, content shifting).
 * 
 * Use Cases:
 * - PDF export generation (html2canvas)
 * - Document screenshot/preview generation
 * - Print preview rendering
 * - Any temporary DOM manipulation for measurement/capture
 * 
 * Architecture: These utilities ensure complete isolation from the main
 * page by removing elements from document flow and rendering them in
 * a safe, invisible space.
 */

/**
 * Primary off-screen rendering class
 * 
 * Usage: Apply to any element that needs to be rendered off-screen
 * for capture/measurement without affecting visible layout.
 * 
 * Key Properties:
 * - position: fixed - Removes from document flow completely (no layout impact)
 * - left/top: Far negative positioning - Ensures element is off-screen
 * - visibility: hidden - Makes element invisible (still renders for capture)
 * - pointer-events: none - Prevents any interaction
 * - z-index: Very negative - Ensures it's behind all visible content
 * - overflow: hidden - Prevents scrollbars from appearing
 * - max-width/max-height: Prevents viewport expansion
 */
.offscreen-render {
  /* Remove from document flow - NO LAYOUT IMPACT */
  position: fixed !important;
  
  /* Position far off-screen (beyond any viewport) */
  left: -99999px !important;
  top: -99999px !important;
  
  /* Prevent visual artifacts */
  visibility: hidden !important;
  opacity: 0 !important;
  
  /* Prevent interaction */
  pointer-events: none !important;
  
  /* Ensure it's behind everything */
  z-index: -999999 !important;
  
  /* Prevent scrollbars and viewport expansion */
  overflow: hidden !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  
  /* Prevent transforms/animations from making it visible */
  transform: none !important;
  transition: none !important;
  animation: none !important;
  
  /* Ensure it doesn't create stacking context issues */
  isolation: isolate !important;
  
  /* Prevent any user interaction */
  user-select: none !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  
  /* Prevent touch interactions on mobile */
  touch-action: none !important;
  -webkit-touch-callout: none !important;
}

/**
 * Variant for elements that need to maintain their natural dimensions
 * for accurate capture (e.g., PDF export with specific page sizes)
 */
.offscreen-render--preserve-size {
  @extend .offscreen-render;
  
  /* Allow element to maintain its natural dimensions */
  max-width: none !important;
  max-height: none !important;
  width: auto !important;
  height: auto !important;
  
  /* Ensure dimensions are respected during capture */
  box-sizing: border-box !important;
}

/**
 * Variant for elements that need white background (e.g., PDF exports)
 */
.offscreen-render--white-bg {
  @extend .offscreen-render--preserve-size;
  background-color: #ffffff !important;
}

/**
 * Variant for elements that need transparent background (e.g., screenshots with alpha)
 */
.offscreen-render--transparent-bg {
  @extend .offscreen-render--preserve-size;
  background-color: transparent !important;
}

/**
 * Helper class to ensure body/html stay stable during off-screen renders
 * Apply to body element when performing off-screen operations to prevent
 * any layout shifts or scroll jumps.
 */
body.offscreen-render-active {
  /* Lock scroll position during off-screen operations */
  overflow: hidden !important;
  
  /* Prevent any layout shifts */
  position: relative !important;
  
  /* Maintain current dimensions */
  width: 100vw !important;
  height: 100vh !important;
  
  /* Prevent overscroll that could trigger navigation */
  overscroll-behavior: none !important;
}

/**
 * Container stabilizer - apply to main content during off-screen operations
 * to prevent shifts in layout or scroll position.
 */
.offscreen-render-stabilizer {
  /* Maintain position and dimensions */
  position: relative !important;
  
  /* Prevent layout recalculation */
  contain: layout style !important;
  
  /* Prevent shifts during capture */
  will-change: auto !important;
}

/**
 * Debug mode - Uncomment to visualize off-screen elements during development
 * WARNING: Only use for debugging, never in production!
 */
/*
.offscreen-render {
  left: 0 !important;
  top: 0 !important;
  visibility: visible !important;
  opacity: 0.5 !important;
  z-index: 999999 !important;
  border: 5px solid red !important;
}
*/

`, "",{"version":3,"sources":["webpack://./src/styles/OffscreenRenderUtils.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;EAkBE;;AAEF;;;;;;;;;;;;;;EAcE;AACF;EACE,iDAAiD;EACjD,0BAA0B;;EAE1B,kDAAkD;EAClD,yBAAyB;EACzB,wBAAwB;;EAExB,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;;EAErB,wBAAwB;EACxB,+BAA+B;;EAE/B,kCAAkC;EAClC,2BAA2B;;EAE3B,8CAA8C;EAC9C,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;;EAE5B,yDAAyD;EACzD,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;;EAE1B,qDAAqD;EACrD,6BAA6B;;EAE7B,iCAAiC;EACjC,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;;EAEhC,yCAAyC;EACzC,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;;;EAGE;AACF;EACE,yBAAyB;;EAEzB,qDAAqD;EACrD,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;;EAEvB,mDAAmD;EACnD,iCAAiC;AACnC;;AAEA;;EAEE;AACF;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;;EAEE;AACF;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;;;;EAIE;AACF;EACE,sDAAsD;EACtD,2BAA2B;;EAE3B,8BAA8B;EAC9B,6BAA6B;;EAE7B,gCAAgC;EAChC,uBAAuB;EACvB,wBAAwB;;EAExB,qDAAqD;EACrD,oCAAoC;AACtC;;AAEA;;;EAGE;AACF;EACE,qCAAqC;EACrC,6BAA6B;;EAE7B,iCAAiC;EACjC,gCAAgC;;EAEhC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;;;EAGE;AACF;;;;;;;;;CASC","sourcesContent":["/**\n * ===============================================\n * OFF-SCREEN RENDERING UTILITIES\n * ===============================================\n * \n * Purpose: Provide robust CSS classes for rendering elements off-screen\n * without affecting the main page layout, scroll position, or causing\n * visual artifacts (flashing, content shifting).\n * \n * Use Cases:\n * - PDF export generation (html2canvas)\n * - Document screenshot/preview generation\n * - Print preview rendering\n * - Any temporary DOM manipulation for measurement/capture\n * \n * Architecture: These utilities ensure complete isolation from the main\n * page by removing elements from document flow and rendering them in\n * a safe, invisible space.\n */\n\n/**\n * Primary off-screen rendering class\n * \n * Usage: Apply to any element that needs to be rendered off-screen\n * for capture/measurement without affecting visible layout.\n * \n * Key Properties:\n * - position: fixed - Removes from document flow completely (no layout impact)\n * - left/top: Far negative positioning - Ensures element is off-screen\n * - visibility: hidden - Makes element invisible (still renders for capture)\n * - pointer-events: none - Prevents any interaction\n * - z-index: Very negative - Ensures it's behind all visible content\n * - overflow: hidden - Prevents scrollbars from appearing\n * - max-width/max-height: Prevents viewport expansion\n */\n.offscreen-render {\n  /* Remove from document flow - NO LAYOUT IMPACT */\n  position: fixed !important;\n  \n  /* Position far off-screen (beyond any viewport) */\n  left: -99999px !important;\n  top: -99999px !important;\n  \n  /* Prevent visual artifacts */\n  visibility: hidden !important;\n  opacity: 0 !important;\n  \n  /* Prevent interaction */\n  pointer-events: none !important;\n  \n  /* Ensure it's behind everything */\n  z-index: -999999 !important;\n  \n  /* Prevent scrollbars and viewport expansion */\n  overflow: hidden !important;\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  \n  /* Prevent transforms/animations from making it visible */\n  transform: none !important;\n  transition: none !important;\n  animation: none !important;\n  \n  /* Ensure it doesn't create stacking context issues */\n  isolation: isolate !important;\n  \n  /* Prevent any user interaction */\n  user-select: none !important;\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  \n  /* Prevent touch interactions on mobile */\n  touch-action: none !important;\n  -webkit-touch-callout: none !important;\n}\n\n/**\n * Variant for elements that need to maintain their natural dimensions\n * for accurate capture (e.g., PDF export with specific page sizes)\n */\n.offscreen-render--preserve-size {\n  @extend .offscreen-render;\n  \n  /* Allow element to maintain its natural dimensions */\n  max-width: none !important;\n  max-height: none !important;\n  width: auto !important;\n  height: auto !important;\n  \n  /* Ensure dimensions are respected during capture */\n  box-sizing: border-box !important;\n}\n\n/**\n * Variant for elements that need white background (e.g., PDF exports)\n */\n.offscreen-render--white-bg {\n  @extend .offscreen-render--preserve-size;\n  background-color: #ffffff !important;\n}\n\n/**\n * Variant for elements that need transparent background (e.g., screenshots with alpha)\n */\n.offscreen-render--transparent-bg {\n  @extend .offscreen-render--preserve-size;\n  background-color: transparent !important;\n}\n\n/**\n * Helper class to ensure body/html stay stable during off-screen renders\n * Apply to body element when performing off-screen operations to prevent\n * any layout shifts or scroll jumps.\n */\nbody.offscreen-render-active {\n  /* Lock scroll position during off-screen operations */\n  overflow: hidden !important;\n  \n  /* Prevent any layout shifts */\n  position: relative !important;\n  \n  /* Maintain current dimensions */\n  width: 100vw !important;\n  height: 100vh !important;\n  \n  /* Prevent overscroll that could trigger navigation */\n  overscroll-behavior: none !important;\n}\n\n/**\n * Container stabilizer - apply to main content during off-screen operations\n * to prevent shifts in layout or scroll position.\n */\n.offscreen-render-stabilizer {\n  /* Maintain position and dimensions */\n  position: relative !important;\n  \n  /* Prevent layout recalculation */\n  contain: layout style !important;\n  \n  /* Prevent shifts during capture */\n  will-change: auto !important;\n}\n\n/**\n * Debug mode - Uncomment to visualize off-screen elements during development\n * WARNING: Only use for debugging, never in production!\n */\n/*\n.offscreen-render {\n  left: 0 !important;\n  top: 0 !important;\n  visibility: visible !important;\n  opacity: 0.5 !important;\n  z-index: 999999 !important;\n  border: 5px solid red !important;\n}\n*/\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
